import { useState, useEffect } from 'react';
import { State } from 'shared/types/account/State';
import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';
import { useProjSettings } from '@/frontastic/hooks/useProjectSettings/useProjectSettings';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
interface Props {
  id: string;
  classname: string;
  disabled?: boolean;
  label: string;
  errors: any;
  setValue: any;
  initialState: string;
  onChange?: any;
  register: any;
}

export const StateDropDown: React.FC<Props> = ({
  id,
  classname,
  disabled,
  label,
  errors,
  setValue,
  initialState,
  register,
  onChange,
}) => {
  const projectSettings: ProjectSettings = useProjSettings();
  const [stateLocations, setStateLocations] = useState([]);
  const [selectedState, setSelectedState] = useState<string>('');

  useEffect(() => {
    setValue(label, selectedState);
  }, [setValue, label, selectedState]);

  const handleSelectState = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    setSelectedState(selectedValue);
    setValue(label, selectedValue);
    if (onChange) {
      onChange(selectedValue);
    }
  };

  useEffect(() => {
    if (projectSettings) {
      const stateLocations = projectSettings.shippingLocations ? JSON.parse(projectSettings.shippingLocations)?.US : [];
      const currentState = stateLocations?.filter((items: any) => items.code === initialState);

      if (initialState) {
        setSelectedState(currentState[0]?.code);
      } else {
        setSelectedState('');
      }
      setStateLocations(stateLocations);
    }
  }, [projectSettings, initialState]);

  return (
    <section className="relative w-full">
      <select
        id={id}
        className={
          'peer block appearance-none truncate rounded-lg border bg-transparent p-4 text-base text-black ' +
          (errors[label] ? ' border-2 border-scarletRed text-scarletRed ' : ' border-foggyGray text-black ') +
          classname
        }
        value={selectedState}
        placeholder="*State"
        onChange={handleSelectState}
        disabled={disabled}
        {...register(label, { onChange: handleSelectState })}
      >
        <option value="" disabled hidden>
          {mapLocaleToMeaningfulFormat().state}
        </option>
        {stateLocations?.map((state: State, index: number) => (
          <option key={index} value={state.code}>
            {`${state.code} - ${state.name}`}
          </option>
        ))}
      </select>
      {selectedState ? (
        <label
          htmlFor={id}
          className={
            'absolute start-1 top-2 ml-1 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-base duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4 ' +
            (errors[label]?.message && 'text-scarletRed')
          }
        >
          {mapLocaleToMeaningfulFormat().state}
        </label>
      ) : null}
      {errors[label] && <p className="absolute ml-2 mt-2 text-sm text-scarletRed">{errors[label]?.message}</p>}
    </section>
  );
};
